export default {
    showFiltersButton: 'Search',
    showChargingStationFiltersButton: 'Search',
    clearFiltersButton: 'Clear',

    serviceSelect: 'Select the desired service',
    serviceMaintenance: 'Arranging service',
    serviceTires: 'Tires',
    serviceCallingAction: 'Recall',
    serviceChargingStations: 'Charging stations',
    searchAddress: 'Search the address',
    searchAddressPlaceholder: 'Search for a city, street, or postal code',
    searchAddressSelectNote: 'Please select the address from the given choice.',
    searchArea: 'Search nearby',

    minimumPower: 'Minimum power',
    all: 'All',
    operators: 'Operators',

    submitSearch: 'Search'
}
